<app-password-recovery-by-phone-number-state
  [accountRestore]="accountRestore"
  [phoneNumber]="phoneNumber"
  (closePassRecovery)="close()"
  (goBackFromPassRecovery)="goToSelectRecoveryMethodState()">
</app-password-recovery-by-phone-number-state>
